import React from 'react';

import { Comment as CommentType } from '@utils/backend-api/comments';

import Comment from './Comment';

export default function CommentsFeed({
  comments,
  level,
  setParentReplyingTo,
}: {
  comments: CommentType[];
  level?: number;
  setParentReplyingTo?: (replyingTo: string) => void;
}) {
  return (
    <div className="comment-feed">
      {comments.map((comment) => (
        <Comment
          key={comment.id}
          comment={comment}
          level={level}
          setParentReplyingTo={setParentReplyingTo}
        />
      ))}
    </div>
  );
}
